import { Pipe, PipeTransform } from '@angular/core';

import { DeliveryPoint } from '$core/models/delivery-point';

@Pipe({
  name: 'filterByType',
})
export class FilterByTypePipe implements PipeTransform {
  public transform(
    list: DeliveryPoint[],
    selectedType: string | null
  ): DeliveryPoint[] {
    if (selectedType === null || !list) {
      return list;
    }

    return list.filter(({ type }) => type === selectedType);
  }
}
